
import { Component } from '@angular/core';
import { OverlayContentComponent } from '@acaprojects/ngx-widgets';

@Component({
    selector: 'room-info',
    templateUrl: './room-info.template.html',
    styleUrls: ['./room-info.styles.scss']
})
export class RoomInfoComponent extends OverlayContentComponent {

}
